import { makeStyles } from "@mui/styles";
import { LoginLeftImg, LoginRightImg } from "../../assets/images";
import Theme from "../../themes/theme";

export default makeStyles((theme: Theme) => ({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    top: 0,
    left: 0,
  },
  form: {
    marginTop: "20px",
  },
  formContainer: {
    backgroundImage: `url(${LoginLeftImg})`,
    backgroundSize: "cover",
    width: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      minWidth: "fit-content",
    },
    backgroundColor: theme.palette.UI.white,
  },

  logotypeFormImage: {
    width: "50%",
    height: "10%",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },

  optOutImage: {
    width: "100%",
    height: "50%",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
    marginLeft: "30%",
  },

  greeting: {
    fontSize: "16px",
    fontWeight: 700,
    color: theme.palette.UI.grey_900,
    marginTop: theme.spacing(2),
  },

  subGreeting: {
    fontSize: "10px",
    fontWeight: 700,
    color: theme.palette.UI.warn,
    marginTop: theme.spacing(2),
  },

  customWrapper: {
    maxWidth: "370px",
    width: "90%",
    marginBottom: "4%",
    [theme.breakpoints.between("sm", "md")]: {
      width: "50%",
    },
  },

  logotypeContainer: {
    backgroundImage: `url(${LoginRightImg})`,
    backgroundSize: "cover",
    width: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "20px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "50%",
      marginTop: "10px",
    },
  },

  optOutContainer: {
    width: "60%",
    position: "relative",
  },

  optOutHeading: {
    color: "#fff",
    fontSize: "24px",
  },

  optOutText: {
    fontSize: "16px",
    color: "#fff",
  },
  copyright: {
    marginTop: theme.spacing(4),
    whiteSpace: "nowrap",
    width: "100%",
    right: "10px",
    bottom: "10px",
    textAlign: "center",
    color: theme.palette.UI.white,
  },
  formButton: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  containerButton: {
    backgroundColor: `${theme.palette.UI.secondary_rose} !important`,
    justifyContent: "center",
    textTransform: "none",
    fontSize: "16px",
    maxHeight: "36px",
    height: "36px",
    alignItems: "center",
    border: `1px solid ${theme.palette.UI.secondary_rose}`,
    boxSizing: "border-box",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },

  containerButtonText: {
    color: theme.palette.UI.white,
    lineHeight: "normal",
  },
  error: {
    fontSize: "12px",
    color: theme.palette.UI.dark_rose,
    textAlign: "center",
    marginTop: "10px",
  },
}));
